export const documentOptions = {
  cMapUrl: 'cmaps/',
  cMapPacked: true,
};

export const contractUrl = "https://s3.amazonaws.com/fabricator-signed-documents/" +
  "ProductionQkb_251108_773cfe8e-a1ef-425b-9238-b3ecc59af7e3-b2d05b5c-2c88-4053-b127-e38c89528e1a-no-tags.pdf";

export const bundleReactPdf = "https://d3d4bzhtpt24up.cloudfront.net/shared/js/react-pdf-dashboard-bundle.min.js";
// export const bundleReactPdf = "/js/react-pdf-dashboard-bundle.min.js";

export const accountNumberRegex = /^\d{6,17}$/;

export const routingNumberRegex = /^\d{9}$/;
